import { useTranslation } from "react-i18next";

import { MultiSelectChipsCombobox } from "src/components/MultiSelectChipsCombobox";
import { useExerciseMovementPatterns } from "src/state/exerciseMovementPatterns";
import { type TranslationKey } from "src/types";

interface ExerciseMovementPatternsComboboxProps {
  value: string[];
  onChange: (value: string[]) => void;
  placeholder: string;
}

export function ExerciseMovementPatternsCombobox(
  props: ExerciseMovementPatternsComboboxProps,
) {
  const { t } = useTranslation();
  const movementPatterns = useExerciseMovementPatterns();

  const items = movementPatterns.map((movementPattern) => {
    return {
      id: movementPattern.id,
      label: t(
        `exerciseMovementPatterns.${movementPattern.name}` as TranslationKey,
      ),
    };
  });

  return (
    <MultiSelectChipsCombobox
      items={items}
      value={props.value}
      onChange={props.onChange}
      placeholder={props.placeholder}
      emptyText={t("dataTable.noResults")}
    />
  );
}
